import * as React from 'react';
import {Component, ReactElement} from 'react';
import {RouteComponentProps} from 'react-router';
import {trackOnce} from '../../../utils/tracker';
import {AuthContent as Content} from '../content';
import {AuthFooter as Footer} from '../footer';
import {AuthHeader as Header} from '../header';
import {AuthLabel as Label} from '../label';
import {AuthModal as Modal} from '../modal/modal';
import {AuthLink as Link} from '../link/link';

export interface IAuthSignUpProps extends RouteComponentProps<{}> {
}

export class AuthSignUp extends Component<IAuthSignUpProps, {}> {
  public render(): ReactElement<any> {
    const {history} = this.props;

    return (
      <Modal
        label={'Join Pramp'}
        onClose={() => history.push('/')}
      >
        <Header>Join Pramp</Header>

        <Content>
          <div style={{
              background: '#ffeab4',
              border: '1px solid #eed5a8',
              color: '#794f02',
              padding: '14px 16px',
              boxShadow: '0 0 2px rgba(0, 0, 0, .1)',
              borderRadius: '10px',
              fontWeight: 400,
          }}>
            As of July 2024, all new Pramp sessions are hosted on{' '}
              <span style={{fontWeight: 600}}>
                  Exponent Practice
              </span>
              . It's still free to use. Get access to more questions, improved peer matching, and a complete interview prep platform.{' '}
              <a
                  href='https://www.pramp.com/exponent/practice?ref=pramp&utm_source=pramp&utm_campaign=pramp_modal'
                  style={{textDecoration: 'underline'}}
              >
                  Try it now
              </a>
              .
          </div>
        </Content>

        <Footer>
          <Label>Already a member?</Label>
          <Link url={'/sign-in'}>Log in</Link>
        </Footer>
      </Modal>
    );
  }

  public componentDidMount(): void {
    trackOnce('signup');
  }
}
